import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Inbox } from "lucide-react";
import { api } from "../lib/api";
import { can } from "../lib/permissions";
import { fmtDateTime } from "../lib/format";
import { useAuth } from "../context/AuthContext";
import { Card } from "./ui/card";
import { StatusPill } from "./StatusBadge";

const ACTION = { archive: ["Archiviazione", "tone-amber"], restore: ["Ripristino", "tone-sky"], delete: ["Eliminazione", "tone-red"] };

/** Requests waiting for this person's decision; each opens the vehicle, where it is approved or rejected. */
export default function VehicleRequests() {
  const { user } = useAuth();
  const decides = can(user, "vehicles.archive") || can(user, "vehicles.delete");
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!decides) return undefined;
    let live = true;
    api.get("/vehicle-requests").then(({ data }) => { if (live) setRows(data.requests || []); }).catch(() => {});
    return () => { live = false; };
  }, [decides]);
  if (!decides || rows.length === 0) return null;
  return (
    <Card className="p-4" data-testid="vehicle-requests">
      <div className="mb-2 flex items-center gap-2">
        <span className="icon-tile h-8 w-8 rounded-lg tone-amber" aria-hidden="true"><Inbox className="h-4 w-4" /></span>
        <h2 className="font-heading text-base font-semibold">Richieste da decidere ({rows.length})</h2>
      </div>
      <ul className="divide-y divide-border">
        {rows.map(({ vehicle, request }) => (
          <li key={request.id}>
            <Link to={`/veicoli/${vehicle.id}`} className="flex min-h-12 items-center gap-3 rounded-lg px-2 py-2 hover:bg-secondary/60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring">
              <StatusPill tone={ACTION[request.action][1]}>{ACTION[request.action][0]}</StatusPill>
              <span className="min-w-0 flex-1">
                <span className="font-mono font-semibold text-primary">{vehicle.plate}</span>
                <span className="ml-2 text-sm text-muted-foreground">{vehicle.brand} {vehicle.model}</span>
                <span className="block truncate text-xs text-muted-foreground">«{request.reason}» · {request.requester_name}, {fmtDateTime(request.created_at)}</span>
              </span>
              <ChevronRight className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
            </Link>
          </li>
        ))}
      </ul>
    </Card>
  );
}
